import { Injectable, inject } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import { TestRotaDataService } from './test-rota-data.service';
import { RotaResponse } from '../../../interfaces/response/RotaResponses';

/**
 * This service intercepts {@link RotaService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryRotaDataService implements InMemoryHttpClient {
  private testRotaDataService = inject(TestRotaDataService);


  /**
   * Intercepts HTTP DELETE request of {@link RotaService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP GET request of {@link RotaService}. Gets all required records from an in-memory data store.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
        if (reqInfo.req.url.includes('errors')) {
          const storeId = reqInfo.req.url.split('/errors')[0].split('rotas/')[1];
          return this.getStoreErrors(storeId);
        }
        if (reqInfo.req.url.includes('rotas/')) {
          const week = reqInfo.req.url.split('rotas/')[1];
          return this.getRota(week);
        }
        const store = reqInfo.query.get('store')[0];
        const fromWeek = reqInfo.query.get('fromWeek')[0];
        const toWeek = reqInfo.query.get('toWeek')[0];
        return this.getRotaSummaries(store, fromWeek, toWeek);
      }
    );
  }

  /**
   * Intercepts HTTP POST request of {@link RotaService}.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PUT request of {@link RotaService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link RotaService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  private getRotaSummaries(storeId: string, from: string, to: string): ResponseOptions {
    return {
      body: this.testRotaDataService.getRotaSummaries(storeId, from, to),
      status: STATUS.OK
    };
  }

  private getRota(date: string): ResponseOptions {
    const rota: RotaResponse = {
      rotaAssignments: this.testRotaDataService.getRotaAssignments(date),
      roleAssignments: this.testRotaDataService.getRoleAssignments(date),
      availabilityAssignments: this.testRotaDataService.getAvailabilityAssignments(date),
      fullDayAbsenceAssignments: this.testRotaDataService.getFullDayAbsenceAssignments(date),
      halfDayAbsenceAssignments: this.testRotaDataService.getHalfDayAbsenceAssignments(date)
    };
    return {
      body: rota,
      status: STATUS.OK
    };
  }

  private getStoreErrors(storeId: string): ResponseOptions {
    const rotaErrors = {
      F3: ['Error: error 1', 'Error: error 2', 'Error: error 3'],
      '01': ['Warning: warning 2', 'Warning: warning 2']
    };

    return {
      body: rotaErrors[storeId] ? rotaErrors[storeId] : [],
      status: STATUS.OK
    };
  }
}

